import React from 'react';

const WizardStepHeaderItem = (props) => {
    let itemStyle = '';
    if(props.variant === 'active') { itemStyle = 'active'}
    if(props.variant === 'inactive') { itemStyle = 'inactive'}
    if(props.variant === 'complete') { itemStyle = 'complete'}
    return (
        <li className={itemStyle}>
            <span>{props.index}</span>
            <span>{props.label}</span>
        </li>
    )
};

export default WizardStepHeaderItem;